import { DispoEmploymentTabIdEnum } from '../../models/DispoEmploymentTabId.enum';
import { Employment } from '../../models/employment';
import { RoleEnum } from '../../models/role.enum';
import { User } from '../../models/user';
import { getDispoTabQuery } from '../jobs-query/getDispoTabQuery';
import { getEmploymentDispoDepartmentQuery } from './getEmploymentDispoDepartmentQuery';
import { getEmploymentRangeQuery } from './getEmploymentRangeQuery';
import { getEmploymentSearchQuery } from './getEmploymentSearchQuery';

export function getDispoEmploymentsQuery(
  user: User,
  tabId: DispoEmploymentTabIdEnum,
  search: string | undefined,
  range: string | undefined,
  showCanceled: boolean = false,
): Mongo.Selector<Employment> {
  if (user.role !== RoleEnum.DISPO) {
    return {};
  }

  const $and: Mongo.Selector<Employment>[] = [
    getDispoTabQuery(tabId, user, showCanceled),
    getEmploymentDispoDepartmentQuery(user),
  ];

  if (search) {
    $and.push(getEmploymentSearchQuery(search));
  }
  if (range) {
    $and.push(getEmploymentRangeQuery(range));
  }
  return {
    $and,
  };
}
